import { useState } from 'react'
import i18n from '../config/i18n'
import { getLanguageDetected } from '../helpers/language'

const useLanguage = defaultLanguage => {
  const detectLanguage = defaultLanguage ? defaultLanguage : getLanguageDetected()
  const [lang, setLang] = useState(detectLanguage)

  return {
    lang,
    setLanguage: language => {
      localStorage.setItem('lang', language)
      i18n.changeLanguage(language)
      setLang(language)
    },
  }
}

export default useLanguage
